import axios from 'axios'
import Qs from 'qs'
// import store from '@/store'
// import { getToken, getMenu } from '@/utils/auth'
const request = (data, b, contentType='application/json') => {
  // create an axios instance
  const isJSON = !!b
  // create an axios instance
  const service = axios.create({
    // withCredentials:true,
    // baseURL: process.env.BASE_API, // api 的 base_url
    timeout: 50000 // request timeout
  })
  // request interceptor
  service.interceptors.request.use(
    config => {
      // console.log(config)
      // Do something before request is sent
      // if (store.getters.token) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      // config.headers['uuid'] = getToken()
      // }
      // config.headers['menuId'] = getMenu() || 0// 传入菜单的一级id
      // config.headers['token'] = getToken() || null
      // config.headers['platform'] = 'pc' // 平台参数
      if (config.method === 'get') {
        config.params = {
          // uuid: getToken(),
          ...config.params
        }
      } else if (config.method === 'post') {
        if (isJSON) {
          if (config.contentType) {
            config['Content-Type'] = config.contentType
          } else {
            config['Content-Type'] = contentType
          }
          config.data = config.data
        } else {
          if (config.data instanceof FormData) {
            // config.data.append('uuid', getToken())
          } else {
            config.data = Qs.stringify({
              // uuid: getToken(),
              ...config.data
            }, { indices: false })
          }
        }
      }
      return config
    },
    error => {
      // Do something with request error
      console.log(error) // for debug
      Promise.reject(error)
    }
  )

  // response interceptor
  service.interceptors.response.use(

    response => {
      // console.log(response)
      // if (response.data.code === -999) {
      //   // 用户未登录
      //   store.dispatch('FedLogOut').then(() => {
      //     location.reload() // 为了重新实例化vue-router对象 避免bug
      //   })
      // } else if (response.data.code === -998) {
      //   Message({
      //     message: '你没有相关权限',
      //     type: 'error',
      //     duration: 3 * 1000
      //   })
      // }
      return response
    },
    /**
     * 下面的注释为通过在response里，自定义code来标示请求状态
     * 当code返回如下情况则说明权限有问题，登出并返回到登录页
     * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
     * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
     */
    response => {
      // const res = response.data
      // // console.log('这里')
      // console.log(response)
      // if (res.code !== 0) {
      //   return Promise.reject('error')
      // } else {
      //   return response.data
      // }
      console.log(response)
    },
    error => { // for debug
      // Message({
      //   message: error.message,
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      return Promise.reject(error)
    }
  )
  return service(data)
}

export default request


// WEBPACK FOOTER //
// ./src/utils/request.js